import { useRunMeterSchedule } from "@features/mx/readCycleManagement/hooks";
import { Button } from "@shared/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@shared/ui/dialog";
import { useParams } from "react-router-dom";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";

const RunCycleMessage = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (value: boolean) => void;
}) => {
  const { schedule_id } = useParams();
  const utilityId = useRemoteUtilityId();
  const runMeterSchedule = useRunMeterSchedule();
  const handleSubmit = () => {
    runMeterSchedule.mutateAsync({
      schedule_id: Number(schedule_id),
      remote_utility_id: Number(utilityId),
    });
    setOpen(false);
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="page-title">Start Run Now</DialogTitle>
          <DialogDescription className="page-subtitle">
            Start a read cycle run immediately based on the current schedule.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">
            This will evaluate the latest run status and either start a new run
            or prompt you if a run is already in progress.
          </p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button onClick={() => handleSubmit()}>Proceed</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RunCycleMessage;
